export function compare(key, order = 'asc') {
  return (a, b) => {
    if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
      // property doesn't exist on either object
      return 0;
    }

    const varA = typeof a[key] === 'string' ? a[key].toUpperCase() : a[key];
    const varB = typeof b[key] === 'string' ? b[key].toUpperCase() : b[key];

    let comparison = 0;

    if (varA > varB) {
      comparison = 1;
    } else if (varA < varB) {
      comparison = -1;
    }
    return order === 'desc' ? comparison * -1 : comparison;
  };
}

export function isEmpty(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      return false;
    }
  }
  return true;
}

export function htmlDecode(input) {
  var e = document.createElement('div');
  e.innerHTML = input;
  return e.childNodes.length === 0 ? '' : e.childNodes[0].nodeValue;
}

export function allReplace(obj) {
  var retStr = this;
  for (var x in obj) {
    retStr = retStr.replace(new RegExp(x, 'g'), obj[x]);
  }
  return retStr;
}

export function queryString(params) {
  return Object.keys(params)
    .map((key) => key + '=' + params[key])
    .join('&');
}

export function getObjectNextPrev(data, value, phrase, loop) {
  const oFunctions = {};

  oFunctions.keys = {};

  oFunctions.keys.next = (o, id, loop) => {
    const keys = Object.keys(o);
    const idIndex = keys.indexOf(id);
    const nextIndex = idIndex + 1;
    if (nextIndex >= keys.length) {
      //we're at the end, there is no next
      if (loop) {
        return keys[0];
      } else {
        return;
      }
    }
    const nextKey = keys[nextIndex];
    return nextKey;
  };

  oFunctions.keys.prev = (o, id, loop) => {
    const keys = Object.keys(o);
    const idIndex = keys.indexOf(id);
    const nextIndex = idIndex - 1;

    if (idIndex === 0) {
      //we're at the beginning, there is no previous
      if (loop) {
        return keys.slice(-1)[0];
      } else {
        return;
      }
    }
    const nextKey = keys[nextIndex];
    return nextKey;
  };
}

export function toFormData(obj, form, namespace) {
  let fd = form || new FormData();
  let formKey;

  for (let property in obj) {
    if (obj.hasOwnProperty(property) && obj[property]) {
      if (namespace) {
        formKey = namespace + '[' + property + ']';
      } else {
        formKey = property;
      }

      // if the property is an object, but not a File, use recursivity.
      if (obj[property] instanceof Date) {
        fd.append(formKey, obj[property].toISOString());
      } else if (
        typeof obj[property] === 'object' &&
        !(obj[property] instanceof File)
      ) {
        toFormData(obj[property], fd, formKey);
      } else {
        // if it's a string or a File object
        fd.append(formKey, obj[property]);
      }
    }
  }

  return fd;
}
